import React from 'react';

const Footer = () => {
  return (
    <footer className='d-flex justify-content-center mt-3' id='footer'>
      <p className='text-light'>
        Desarrollado con <i className="fas fa-heart heart"></i> por <a className='text-light linkFooter' href='https://github.com/LorenaCoheneBaez'>Lorena Cohene Báez</a>
      </p>
    </footer>
  );
}

export default Footer;
